import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import ChatBot from "./react-simple-chatbot";
import axios from 'axios';
import {ThemeProvider} from "styled-components";

const config = {
    webEndpoint: '/chatbot/proxy.php',
};

Object.assign(window.chatBotCfg, config);

const theme = {
    background: '#f5f8fb',
    fontFamily: 'Helvetica Neue',
    headerBgColor: '#EF6C00',
    headerFontColor: '#fff',
    headerFontSize: '15px',
    botBubbleColor: '#EF6C00',
    botFontColor: '#fff',
    userBubbleColor: '#fff',
    userFontColor: '#4a4a4a',
};

for (let key in theme) {
    if (window.chatBotCfg[key]) {
        theme[key] = window.chatBotCfg[key];
    }
}

axios.defaults.headers = {
    'X-ChatBot-Token': window.chatBotCfg.token,
};

ReactDOM.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
          <ChatBot
              floating={window.chatBotCfg.floating}
              placeholder={window.chatBotCfg.placeholder}
              headerTitle={window.chatBotCfg.title}
              botAvatar={window.chatBotCfg.avatar}
              botDelay={window.chatBotCfg.delay ? window.chatBotCfg.delay : undefined}
              minDelay={window.chatBotCfg.minDelay ? window.chatBotCfg.minDelay : undefined}
              maxDelay={window.chatBotCfg.maxDelay ? window.chatBotCfg.maxDelay : undefined}
          />
      </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('chatbot')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
